module.exports = __webpack_public_path__ + "img/no-mapped-products.a66f4b2c.svg";